// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".3fb44ccfcd5c7cbdd94c55423ea48b8c.js";
};